"use client"

import { ChessKing } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ChessKingIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ChessKingIcon = component(Icon)({ as: ChessKing })
